import React, { useState } from 'react';
import { Form, Button, Row, Col } from 'react-bootstrap';
import { reprogramarProgramacion } from '../../api/common';
import { Alertassw } from '../Alertas/Alertassw';

/**
 * Formulario embebido para reprogramar una Programación del calendario.
 */
const EditarProgramacionCalendario = ({ evento, onExito, onCancelar }) => {
  const toInputDate = (d) => {
    if (!d) return '';
    const dt = new Date(d);
    const pad = (n) => String(n).padStart(2, '0');
    return `${dt.getFullYear()}-${pad(dt.getMonth() + 1)}-${pad(dt.getDate())}`;
  };

  const [fechaInicio, setFechaInicio] = useState(toInputDate(evento?.start));
  const [fechaCierre, setFechaCierre] = useState(toInputDate(evento?.end));
  const [observacion, setObservacion] = useState(evento?.descripcion || '');
  const [loading, setLoading] = useState(false);

  const handleGuardar = async (e) => {
    e.preventDefault();
    if (!fechaInicio || !fechaCierre) {
      Alertassw('warning', 'Ingresa las dos fechas');
      return;
    }
    setLoading(true);
    try {
      await reprogramarProgramacion(evento.id, { fechaInicio, fechaCierre, observacion });
      Alertassw('success', 'Programación reprogramada correctamente');
      onExito();
    } catch (err) {
      Alertassw('error', 'No se pudo reprogramar la programación');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form onSubmit={handleGuardar}>
      <h6 className="fw-bold mb-3">Reprogramar: {evento?.title}</h6>
      <Row className="mb-3">
        <Col md={6}>
          <Form.Group>
            <Form.Label>Fecha inicio</Form.Label>
            <Form.Control
              type="date"
              value={fechaInicio}
              onChange={(e) => setFechaInicio(e.target.value)}
              required
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group>
            <Form.Label>Fecha cierre</Form.Label>
            <Form.Control
              type="date"
              value={fechaCierre}
              onChange={(e) => setFechaCierre(e.target.value)}
              required
            />
          </Form.Group>
        </Col>
      </Row>
      <Form.Group className="mb-3">
        <Form.Label>Observación</Form.Label>
        <Form.Control
          as="textarea"
          rows={2}
          value={observacion}
          onChange={(e) => setObservacion(e.target.value)}
          placeholder="Motivo del cambio (opcional)"
        />
      </Form.Group>
      <div className="d-flex gap-2 justify-content-end">
        <Button variant="secondary" onClick={onCancelar} disabled={loading}>
          Cancelar
        </Button>
        <Button variant="primary" type="submit" disabled={loading}>
          {loading ? 'Guardando…' : 'Guardar'}
        </Button>
      </div>
    </Form>
  );
};

export default EditarProgramacionCalendario;
